module.exports = __webpack_public_path__ + "img/media-1.d68af97d.png";